import React, { useEffect, useState } from 'react'
import { Grid, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import { enqueueSnackbar } from 'notistack';
import CustomModal from 'src/components/customerinput/CustomModal';
import CustomInput from 'src/components/customerinput/CustomerInput';
import { useAuthContext } from 'src/auth/useAuthContext';
import createEventDiscount from 'src/services/events/createDiscount';
export default function CreateShareDiscountModal({ close, open, eventData }) {
    const { user, logout } = useAuthContext()
    const [isloading, setIsloading] = useState(false)
    const { handleChange, handleSubmit, values, handleBlur, setFieldValue, errors, touched } = useFormik({
        initialValues: {
            coupon_code: "",
            customer_name: "",
            customer_phone: "",
            customer_email: "",
        },
        // validationSchema: eventDiscount,
        onSubmit: async (value) => {
            try {
                if (!value.valid_from || !value?.valid_till) {
                    enqueueSnackbar('Date is required.', {
                        variant: "error",
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        },
                    });
                    return
                }
                setIsloading(true)
                const { data } = await createEventDiscount(user,
                    {
                        ...value
                    }, logout)
                if (data) {
                    enqueueSnackbar('Discount coupon created..', {
                        variant: "success",
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        },
                    });
                    close()
                }
                console.log(response);
            } catch (err) {
                console.log(err);
                setIsloading(false)

            } finally {
                setIsloading(false)

            }


        }
    })

    useEffect(() => {
        setFieldValue('event', eventData?._id)
    }, [open])
    return (
        <CustomModal heading="Share Discount" open={open} close={close} action={<LoadingButton variant='contained' form="discount" loading={isloading} disabled={isloading} type='form'>Generate</LoadingButton>}>
            <form id="discount" onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>The discount code will be sent to email/phone no added below</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput label="Discount Code" required input={
                            <TextField fullWidth name='coupon_code' value={values?.coupon_code || ''} onChange={handleChange} onBlur={handleBlur} placeholder='Discount Name' helperText={errors?.coupon_code && touched.coupon_code ? errors?.coupon_code : null} error={errors?.coupon_codes && touched?.coupon_codes ? true : false} />} />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput required label="Customer Name" input={<TextField name='customer_name' value={values?.customer_name} helperText={errors?.customer_name && touched.customer_name ? errors?.customer_name : null} error={errors?.customer_name && touched.customer_name ? true : false} onChange={handleChange} onBlur={handleBlur} fullWidth placeholder='Add Name' />} />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput required label="Phone" input={<TextField name='customer_name' value={values?.customer_phone} helperText={errors?.customer_phone && touched.customer_phone ? errors?.customer_phone : null} error={errors?.customer_phone && touched?.customer_phone ? true : false} onChange={handleChange} onBlur={handleBlur} fullWidth placeholder='Add Phone' />} />
                    </Grid>
                    <Grid item xs={12}>
                        <CustomInput required label="Email" input={<TextField name='customer_email' value={values?.customer_email} helperText={errors?.customer_email && touched.customer_email ? errors?.customer_email : null} error={errors?.customer_email && touched?.customer_email ? true : false} onChange={handleChange} onBlur={handleBlur} fullWidth placeholder='Add Email' />} />
                    </Grid>
                </Grid>
            </form>

        </CustomModal>
    )
}
